"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefined = void 0;
function isDefined(t) {
    return t !== undefined;
}
exports.isDefined = isDefined;
//# sourceMappingURL=isDefined.js.map